import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Annotator from "../views/Annotator";
import AnnotatorSidebar from "../views/AnnotatorSidebar";
import AnnotatorAltSidebar from "../views/AnnotatorAltSidebar";
import AnnotatorHeader from "../views/AnnotatorHeader";
import Admin from "../views/Admin";
import Login from "../views/Login";
import $axios from "@/axios-instance";
import ui from "@/store/modules/ui";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin
  },
  {
    path: "/home",
    component: Home,
    children: [
      {
        path: "",
        name: "Home",
        components: {
          header: AnnotatorHeader,
          main: Annotator,
          sidebar: AnnotatorSidebar,
          altsidebar: AnnotatorAltSidebar
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// Authentication
router.beforeEach(async (to, from, next) => {
  // if router is Login, continue
  if (to.name === "Login") {
    ui.setHasUnsavedChange(false);
    next();
    return;
  }

  // if has unsaved change, check on user
  if (ui.hasUnsavedChange && to.name !== "Home") {
    const answer = window.confirm("Changes you made might not be saved");
    if (!answer) {
      next(false);
      return;
    }
  }

  try {
    const res = await $axios.post("/auth");
    if (to.name === "Admin" && !res.data.payload.admin) {
      next(false);
      return;
    }
    ui.setHasUnsavedChange(false);
    next();
  } catch {
    ui.setHasUnsavedChange(false);
    next({ name: "Login" });
  }
});

export default router;
